import { useTranslation } from 'react-i18next'
import { FormInput } from '@microservices/wiskey-react-components'

import { ModalRefPathPicker } from '@pages/GanttChart/components/GanttCreateOrEdit/components/ModalRefPathPicker'

import { FIELD_BIND_TYPE_ENUM, GENERATOR_INPUT_TYPE } from '@constants'
import { AutocompleteOption } from '@types'

type ValueCellProps = {
  typeId?: string | null
  valueFieldName: string
  pathArrayFieldName: string
  isDisabled?: boolean
  isTypeSelected: boolean
  isRequired?: boolean
  defaultRefFieldsObjectOption: AutocompleteOption<string> | null
  refObjectOptions: AutocompleteOption[]
  isChangeRefObjectAllowed?: boolean
  onEditJs?: () => void
  onChangeRootObject?: (value: AutocompleteOption<string>) => void
}

export const ValueCell = ({
  typeId,
  valueFieldName,
  pathArrayFieldName,
  isDisabled,
  isTypeSelected,
  defaultRefFieldsObjectOption,
  refObjectOptions,
  isChangeRefObjectAllowed,
  onEditJs,
  onChangeRootObject,
}: ValueCellProps) => {
  const { t } = useTranslation()

  const isField = typeId === FIELD_BIND_TYPE_ENUM.FIELD
  const isJs = typeId === FIELD_BIND_TYPE_ENUM.JS

  const handleOnChangeRootObject = isChangeRefObjectAllowed ? onChangeRootObject : undefined

  if (!isField) {
    return (
      <FormInput
        disabled={isDisabled || !isTypeSelected}
        inputType={GENERATOR_INPUT_TYPE.INPUT}
        label=''
        name={valueFieldName}
        placeholder={t('commandParameters.inputs.value.placeholder')}
        readOnly={isJs}
        rules={{ required: Boolean(typeId) }}
        additionalBtn={{
          isEnabled: isJs,
          text: t('commandParameters.buttons.edit'),
          color: 'primary',
          variant: 'contained',
          onClick: onEditJs,
        }}
        formInputContainerSx={{
          '& .MuiFormLabel-root': { display: 'none' },
          flexWrap: 'nowrap',
          '& .MuiButton-root': { ml: 0.5 },
        }}
      />
    )
  }

  return (
    <ModalRefPathPicker
      hasClearInInput
      refPickAllowed
      embeddedObjectPickerControllerName={pathArrayFieldName}
      isDisabled={isDisabled || !isTypeSelected}
      isRequired={Boolean(typeId)}
      label=''
      name={valueFieldName}
      object={defaultRefFieldsObjectOption}
      pickerName={valueFieldName}
      refObjectOptions={refObjectOptions}
      sx={{
        '& .MuiTypography-root': { display: 'none' },
        '& .MuiButton-root': { margin: 0, width: 64 },
        '& .MuiGrid-root.MuiGrid-container': { marginBottom: 0 },
        '& .MuiBox-root': { marginBottom: 0 },
      }}
      onChangeRootObject={handleOnChangeRootObject}
    />
  )
}
